import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

// 禁用浏览器刷新时的自动滚动恢复（必须最早执行）
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
}

import store from './store'
app.use(store)

import router from './router'
app.use(router)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementIcons from '@element-plus/icons-vue'
// 将 element-plus 的图标库注册到全局
for (var key in ElementIcons) {
    app.component(`ElIcon${ElementIcons[key].name}`, ElementIcons[key])
}
// Element Plus locale 由 App.vue 的 el-config-provider 动态绑定，不再在此硬编码
app.use(ElementPlus, {
    size: store.state.settings.elementSize
})

import { useI18n } from './locales'
useI18n(app)

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
app.use(ContextMenu)

import globalProperties from '@/util/global.properties'
globalProperties(app)

// 自定义指令
import directive from '@/util/bmqy.directive'
directive(app)

// 错误日志上报
import errorLog from '@/util/error.log'
errorLog(app)

// 加载 svg 图标
import 'virtual:svg-icons-register'
import 'remixicon/fonts/remixicon.css'

// 全局样式
import '@/assets/styles/globals.scss'
// 用于去掉eazyplayer警告,开发时禁用，打包开启
app.config.warnHandler = (msg, instance, trace) => {}

// 设置缓存  setCaCheOne 为回到第一页  setCaCheNoOne为不会到第一页刷新
import setCache from '@/util/setCache'
const { setCacheOne, setCacheNoOne } = setCache()

app.config.globalProperties.$setCacheOne = setCacheOne
app.config.globalProperties.$setCacheNoOne = setCacheNoOne

// 表格
import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
app.use(VxeTable)
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
app.use(VxeUI)

app.mount('#app')
